<script setup lang="ts">
// GSAP is registered globally via plugin
import { nextTick, onMounted, onUnmounted, ref } from "vue";
const nuxtApp = useNuxtApp();
const { ScrollTrigger, loadGSAP } = useGSAP();
const isWorldwideTreksPage = useIsWorldwideTreksPage();

onMounted(() => {
  loadGSAP();
});
const header = ref();
const isActive = ref(false);
const isTrekNavActive = ref(false);

const toggleActive = () => {
  isActive.value = !isActive.value;
};

const toggleTrekNavActive = () => {
  isTrekNavActive.value = !isTrekNavActive.value;
};

onUnmounted(() => {
  // Clean up ScrollTrigger instances for this component
  if (process.client && ScrollTrigger.value) {
    try {
      ScrollTrigger.value.getAll().forEach((trigger: any) => {
        if (trigger.vars.trigger === "body" && trigger.vars.onUpdate) {
          trigger.kill();
        }
      });
    } catch (error) {
      console.warn("Failed to cleanup ScrollTrigger instances:", error);
    }
  }
});

function initScrollDirectionIndicator() {
  if (!process.client) return;

  // Check if header element exists before proceeding
  if (!header.value) {
    console.warn(
      "Header element not found, skipping scroll direction indicator",
    );
    return;
  }

  try {
    header.value.classList.remove("scrolling-down");

    ScrollTrigger.value.create({
      trigger: "body",
      start: "top -20%",
      onUpdate: (self: any) => {
        // Check if header still exists before manipulating it
        if (!header.value) return;

        try {
          if (self.direction === 1) {
            header.value.classList.add("scrolling-down");
            header.value.classList.remove("scrolling-up");
          } else {
            header.value.classList.add("scrolling-up");
            header.value.classList.remove("scrolling-down");
          }
        } catch (error) {
          console.warn("Failed to update header classes:", error);
        }
      },
      onLeaveBack: () => {
        // Check if header still exists before manipulating it
        if (!header.value) return;

        try {
          header.value.classList.remove("scrolling-up");
        } catch (error) {
          console.warn("Failed to remove scrolling-up class:", error);
        }
      },
    });
  } catch (error) {
    console.warn("Failed to initialize scroll direction indicator:", error);
  }
}

// On Suspense resolved event
nuxtApp.hook("page:finish", async () => {
  await nextTick(); // wait for DOM updates

  setTimeout(() => {
    // Check if header element exists before initializing
    if (header.value) {
      initScrollDirectionIndicator();
    } else {
      console.warn(
        "Header element not available for scroll direction indicator",
      );
    }
  }, 750);
});
</script>

<template>
  <header id="header" ref="header">
    <div id="topBar">
      <div class="logo-container">
        <AppLogoWWT v-if="isWorldwideTreksPage" />
        <AppLogo v-else />
      </div>
      <AppNavMenu />
    </div>
    <AppNavMobile
      :is-active="isActive"
      :is-trek-nav-active="isTrekNavActive"
      @toggle-active="toggleActive"
      @toggle-trek-nav-active="toggleTrekNavActive"
    />
  </header>
</template>
